<script>
import vechicleIdentity from './vechicle-identity.vue'
import partsListingAi from './parts-listing-ai.vue'
import SettingsDamageAssessment from "@/components/settings/auto_copilot/settings-damage-assessment.vue";
export default {
  name: 'auto-copilot',
  components: {SettingsDamageAssessment, vechicleIdentity,partsListingAi },
  props: {
    value: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      activeTab: 'vehicle',
      vechicle_identification: {
        enabled: false,
      },
      isShowVchIdentity: true,
      isShowDamageAssessment: false,
      isShowParts: false,
    }
  },
  mounted() {},
  methods: {
    setTab(tab) {
      this.activeTab = tab
    },
    isActive(tab) {
      return this.activeTab === tab
    },
    isTabActive(tab){
      if (tab === 'vchIdentity') {
        this.isShowVchIdentity = true
        this.isShowDamageAssessment = false
        this.isShowParts = false
      } else if (tab === 'damageAssessment') {
        this.isShowVchIdentity = false
        this.isShowParts = false
        this.isShowDamageAssessment = true
      } else if (tab === 'parts') {
        this.isShowParts = true
        this.isShowVchIdentity = false
        this.isShowDamageAssessment = false
      }
    }
  },
}
</script>

<template>
  <div style="transform: translateY(-10px)">
    <div class="tabs-component tabs-component-2" style="padding-top: 0px;">
      <div class="tabs-component-w">
        <ul class="nav nav-tabs nav-tabs-2 float-sm-left" role="tablist">
          <li @click="isTabActive('parts')" style="padding-top: 0px" class="tabs-component-tab nav-item">
            <span href="" class="tabs-component-tab-a nav-link" :class="{ active: isShowParts }">Parts</span>
          </li>
          <li @click="isTabActive('vchIdentity')" style="padding-top: 0px" class="tabs-component-tab nav-item">
            <span href="" class="tabs-component-tab-a nav-link" :class="{ active: isShowVchIdentity }">Vch
              identity</span>
          </li>
          <li @click="isTabActive('damageAssessment')"
              style="padding-top: 0px" class="tabs-component-tab nav-item">
            <span href="" class="tabs-component-tab-a nav-link" :class="{ active: isShowDamageAssessment }">
              Damage Assessment</span>
          </li>
        </ul>
      </div>

      <div class="tab-header-orders btn beta">BETA</div>
    </div>
    <parts-listing-ai v-if="isShowParts" v-model="value.copilot.partsInfo" />
    <div class="tab-pane" v-show="isActive('vehicle')">
      <vechicle-identity v-if="isShowVchIdentity" v-model="value.copilot.vehicle" />
    </div>
    <settings-damage-assessment v-if="isShowDamageAssessment" v-model="value.copilot.damage"></settings-damage-assessment>
  </div>
</template>

<style scoped>
.beta {
  cursor: default;
  margin-left: auto;
  position: absolute;
  right: 0;
  top:0;
}

.tab-header-orders {
  border: 2px solid rgb(94, 121, 255);
  background-color: #c9d0ff;
  color: rgb(94, 121, 255);
  font-weight: bold;
}
.tabs-component-tab{
  cursor: pointer;
}

.nav-link {
  cursor: pointer;
}
</style>
